var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import 'rxjs/Rx';
import { HttpClientWrapper } from './httpClient';
var PerfilService = (function (_super) {
    __extends(PerfilService, _super);
    function PerfilService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        return _this;
    }
    PerfilService.prototype.findPerfiles = function (page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 10; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "perfiles.json";
        }
        else {
            wsUrl = this.urlSer() + "perfil/perfiles?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    PerfilService.prototype.deletePfl = function (id, usu) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "notificacion.json";
        }
        else {
            wsUrl = this.urlSer() + "perfil/delete/" + id + "/" + usu;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    PerfilService.prototype.update = function (perfil) {
        var wsUrl;
        wsUrl = this.urlSer() + "perfil/update/?data=" + btoa(SharedService.unescape(encodeURIComponent(perfil)));
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    PerfilService.prototype.insert = function (perfil) {
        var wsUrl;
        wsUrl = this.urlSer() + "perfil/insert/?data=" + btoa(SharedService.unescape(encodeURIComponent(perfil)));
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    PerfilService.prototype.findPfl = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "perfil.json";
        }
        else {
            wsUrl = this.urlSer() + "perfil/find/?id=" + id;
            //console.log('find usuario ' + wsUrl);
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    return PerfilService;
}(SharedService));
PerfilService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClientWrapper])
], PerfilService);
export { PerfilService };
//# sourceMappingURL=perfil.service.js.map